/**
 * Advance (V5 multi-assignment) shifts give every worker their own slot on the shift,
 * carrying the window set while building the shift plus the times that worker clocked.
 * `advance_slot` is the slot belonging to this timesheet's worker.
 */
export const isAdvanceTimesheetRow = (row) =>
  row?.is_advance_shift === true ||
  row?.is_v5_multi_assignment === true ||
  row?.is_multi_assignment === true;

export const getAdvanceSlot = (row) =>
  isAdvanceTimesheetRow(row) ? row?.advance_slot ?? null : null;
